jQuery(function() {
	const $ = jQuery;
	$(".sidebar-toggle").on(BS.Event.Tap, function() {
		$(".sidebar").toggleClass("on");
	});
});
